<!--
반품완료 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons md-24">done</i>
                    반품완료 >
                    <span v-if="stepIn('step-ready')">조회중</span>
                    <span v-if="stepIn('step-confirm')">보관장소(RACK) 확인</span>
                    <span v-if="stepIn('step-input')">정보입력</span>
                </h4>
            </div>

            <div class="uk-modal-body uk-padding-small" v-if="stepIn('step-ready')">
                <loading-icon
                    class="uk-text-middle"
                    bg-color="#fff"
                    fore-color="#333"
                ></loading-icon>
                정보조회중... 잠시만 기다려주세요..
            </div>
            <div class="uk-modal-body uk-padding-small" v-if="stepIn('step-input')">

                <app-input-ex
                    class="uk-margin"
                    type="text"
                    v-model="trackingNo"
                    label="리턴트래킹"
                    init-error-msg=""
                ></app-input-ex>

                <app-input-ex
                    class="uk-margin"
                    type="text"
                    v-model="trackingCost"
                    label="반품운임실비"
                    :placeholder="regionCurrency"
                    init-error-msg=""
                    desc-msg="USPS실비 등.."
                ></app-input-ex>




                <app-input-ex
                    class="uk-margin"
                    type="radio"
                    v-model="labelUseType"
                    label="리턴라벨 사용여부"
                    init-error-msg=""
                    :options="labelUseTypeOptions"
                >
                    <template
                        slot="optionText"
                        slot-scope="{ option }"
                    >
                        <span class="uk-text-bold">{{ option.text }}</span>
                        <span>{{ option.desc }}</span>

                    </template>
                </app-input-ex>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장 (반품완료)
                </button>
            </div>


        </div>

        <!-- 컨펌화면 레이아웃 -->
        <div class="confirm-overlay"  v-show="stepIn('step-confirm')" @click="$refs['storage-input'].focus();" ref="confirm-overlay">
            <div class="confirm-dialog">
                <div class="storage-scan-guide">
                    <i class="material-icons">info</i>
                    잘못된 반품처리를 방지하기위해 보관중인 상품의 보관장소를 확인합니다.
                </div>


                <div class="uk-text-center uk-text-large uk-text-primary uk-margin-top">
                    보관장소(RACK)를 스캔하세요.
                </div>
                <div class="uk-text-center font-size-1d125rem mt-0d5rem">
                    보관라벨이 없는경우, 보관장소를 수동으로 입력하세요
                </div>

                <input
                    type="text"
                    class="scan-input"
                    placeholder="보관장소(RACK) 스캔 or 직접입력"

                    autofocus
                    v-model.trim="storage"
                    @keyup.enter="confirmStorage"

                    ref="storage-input"
                />



                <!-- 스캔결과 -->
                <div class="scan-result">
                    <div class="scanned-storage">{{ storageConfirmTried }}</div>
                    <div class="scanned-msg">{{ storageConfirmFailedMsg }}</div>
                </div>

                <div class="uk-text-center uk-margin-bottom uk-margin-top">


                    <button
                        type="button"
                        class="uk-button uk-button-default"
                        @click="hide"
                    >
                        <span uk-icon="icon: close"></span> 취소
                    </button>

                    <button
                        type="button"
                        class="uk-button uk-button-black uk-margin-left"
                        @click="confirmStorage"
                    >
                        <span uk-icon="icon: check"></span>
                        확인
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import stepAble from "../common/step-able.vue";
    import LoadingIcon from "../common/loading-icon.vue";

    export default {
        components: {LoadingIcon},
        mixins: [
            stepAble,
        ],
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {

                // (bool) 초기화작업 여부
                initialized: false,

                // (string) 현재 진행단계
                currStep: 'step-ready',

                // (array) 진행단계 코드 배열
                steps: [
                    'step-ready',
                    'step-confirm',
                    'step-input',
                ],

                /**
                 * (object) 반품 오브젝트
                 **/
                return: null,

                /**
                 * (object) 상품 오브젝트
                 **/
                prod: null,

                /**
                 * (string) 리턴트래킹
                 */
                trackingNo: null,

                /**
                 * (string) 반품운임실비
                 */
                trackingCost: null,

                /**
                 * (string) 보관장소
                 */
                storage: null,

                /**
                 * (string) 컨펌시도한 보관장소
                 */
                storageConfirmTried: null,

                /**
                 * (string) 보관장소컨펌 실패메세지
                 */
                storageConfirmFailedMsg: null,

                /**
                 * (string) 지역화폐단위
                 */
                regionCurrency: null,

                /**
                 * (string) 리턴라벨 사용여부
                 */
                labelUseType: null,

                /**
                 * (array) 변경가능한 select box 옵션
                 */
                labelUseTypeOptions: [
                    {text: '사용', val: 1, desc: '(업체가 첨부한 리턴라벨을 사용하여 리턴처리 함)'},
                    {text: '미사용', val: 0, desc: '(업체로부터 리턴라벨이 첨부되지 않아 현지택배(UPS등) 사용하여 리턴처리 함)'},
                ],
            };
        },
        computed: {

        },
        mounted() {

        },
        methods: {
            /**
             * 초기화작업 (최초1번만 실행)
             */
            init() {
                if (this.initialized) {
                    return;
                }

                // 컨펌 엘리먼트 body 밑으로 이동
                document.body.appendChild(this.$refs['confirm-overlay']);

                // 모달창 종료이벤트 등록
                UIkit.util.on(this.$el, 'beforehide', () => {
                    this.changeStep('step-ready');
                });
            },

            /**
             * 입력폼 display
             */
            show() {
                this.init();

                UIkit.modal(this.$el).show();

                // 보관장소 없으면 스캔없이 바로 진행
                if (! this.prod.storage) {
                    this.changeStep('step-input');
                    return;
                }

                // 관련변수 초기화
                this.changeStep('step-confirm');
                this.storage = null;
                this.storageConfirmFailedMsg = null;
                this.storageConfirmTried = null;

                // 화면 드로우 끝난뒤 호출되도록 0.5초뒤 호출
                setTimeout(() => {
                    this.$refs['storage-input'].focus();
                }, 500);

            },

            /**
             * 입력폼 종료
             */
            hide() {
                UIkit.modal(this.$el).hide();
            },


            /**
             * 폼
             * @param return_id 반품ID
             */
            form(return_id) {

                // 스텝 초기화
                this.changeStep('step-ready');

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/return-infos/' + return_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.return = response.return;
                    this.prod = response.prod;
                    this.trackingNo = this.return.tracking_no;
                    this.trackingCost = this.return.tracking_cost;
                    if (this.return.label_use_type) {
                        this.labelUseType = this.return.label_use_type.toString();
                    } else {
                        this.labelUseType = '1';
                    }
                    this.regionCurrency = response.region_currency;


                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * 보관장소 컨펌
             */
            confirmStorage() {
                this.storageConfirmTried = this.storage;
                this.storage = null;
                this.storageConfirmFailedMsg = null;
                if (this.prod.storage && this.prod.storage !== this.storageConfirmTried) {
                    this.storageConfirmFailedMsg = '보관장소가 일치하지 않습니다.';
                    return;
                }
                this.changeStep('step-input');
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/return-infos/' + this.return.id + '/done-with-info',
                    data: {
                        '_token': this.csrfToken,
                        'tracking_no': this.trackingNo,
                        'tracking_cost': this.trackingCost,
                        'label_use_type': this.labelUseType,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>

// 컨펌화면
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .confirm-dialog {
        width: 50rem;
        max-width: 90%;

        background-color: #fff;

    }
}

// 보관장소스캔 안내
.storage-scan-guide {
    padding: 1rem;
    color: #DE2D2E;
    border-bottom: 1px solid #eee;
}

// 스캔
.scan-input {
    width: 80%;
    font-size: 1.25rem;
    padding: 1rem;
    margin: 1rem auto;
    display: block;

}

// 스캔 결과
.scan-result {
    margin-top: 1rem;
    text-align: center;
    font-size: 1.25rem;
    .scanned-storage {
        color: #000;
    }
    .scanned-msg {
        color: #DE2D2E;
    }
}
</style>